const inputViewTimeActions = {
  placeholder: 'Escriba aquí...'
};

export default inputViewTimeActions;
